import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal } from 'reactstrap';

import { hideModalTop } from '../actions';

import CollectionEditModal from './Collections/EditModalV2';
import GroupEditModal from './Admin/Groups/EditModal';
import UserEditModal from './Admin/Users/EditModal';
import CommentsCopyModal from './File/CommentsCopyModal';
import ShareTemplateModal from './Share/ShareTemplateModal';
import FileSelectModalEnhanced from './FileSelectModalEnhanced';
import CollectionCreatedModal from './Collections/CollectionCreatedModal';
import FileUploadedModal from './File/FileUploadedModal';
import VideoPlayerModal from './VideoPlayerModal';
import FiltersSelectionModal from './Filters/FiltersSelectionModal';
import ImageEditorDownloadModal from './ImageEditor/DownloadModal';

const MODAL_COMPONENTS = {
  CollectionEditModal,
  GroupEditModal,
  UserEditModal,
  CommentsCopyModal,
  ShareTemplateModal,
  FileSelectModalEnhanced,
  CollectionCreatedModal,
  FileUploadedModal,
  VideoPlayerModal,
  FiltersSelectionModal,
  ImageEditorDownloadModal,
};

class ModalTopRoot extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };

    this.handleClose = this.handleClose.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { modalTop } = this.props;

    if (modalTop && !prevProps.modalTop) {
      this.setOpenState(true);
    }
  }

  setOpenState(open) {
    this.setState({ open });
  }

  handleClose(e) {
    if (e) {
      e.persist();
    }

    const { modalTopProps } = this.props;

    if (modalTopProps.beforeClose) {
      modalTopProps.beforeClose();
    }

    if (e && e.target.href && e.target.href.indexOf('#') > -1) {
      e.preventDefault();
    }

    this.setState({ open: false });

    if (modalTopProps.afterClose) {
      modalTopProps.afterClose();
    }
  }

  render() {
    const {
      modalTop,
      modalTopProps,
      dispatch,
    } = this.props;
    const { open } = this.state;

    if (!modalTop) {
      return null;
    }

    const ModalContent = MODAL_COMPONENTS[modalTop];
    return (
      <Modal
        isOpen={open}
        toggle={this.handleClose}
        className={modalTopProps.className}
        backdrop={modalTopProps.backdrop || 'static'}
        onOpened={() => {
          // Workaround for Reactstrap not adding 'modal-open' class on re-opening modal
          if (!window.$('body').hasClass('modal-open')) {
            window.$('body').addClass('modal-open');
          }
        }}
        onClosed={() => {
          dispatch(hideModalTop());
          this.setState({ open: false });
        }}
        autoFocus={false}
      >
        <ModalContent
          handleClose={this.handleClose}
          {...modalTopProps}
        />
      </Modal>
    );
  }
}

ModalTopRoot.propTypes = {
  dispatch: PropTypes.func.isRequired,
  modalTop: PropTypes.string,
  modalTopProps: PropTypes.object.isRequired,
  beforeClose: PropTypes.func,
  afterClose: PropTypes.func,
};

ModalTopRoot.defaultProps = {
  modalTop: null,
  beforeClose: () => {},
  afterClose: () => {},
};

export default connect(state => state.App)(ModalTopRoot);
